<h1 class="page-title w-50">مركز وكلاء المستثمرين بالهيئة</h1>
<div class="pb-5">
  <div class="d-flex justify-content-between">
    <div class="share-section mb-4 w-50 pt-5">
      <div class="share-text mb-2">شارك المقال على</div>
      <div class="social-icons d-flex justify-content-end gap-2">
        <a href="#" class="social-icon">
          <i class="fa-brands fa-twitter"></i>
        </a>
        <a href="#" class="social-icon">
          <i class="fa-brands fa-facebook-f"></i>
        </a>
      </div>
    </div>
  </div>
  <div class="container-fluid pt-5">
    <p class="text-center" style="color: #990000; font-size: 1.4rem">
      طريقك للاعتماد للعمل في مجال الاستثمار
    </p>
    <div class="investors-agents-content mt-5" dir="rtl">
      <!-- 1- Definition -->
      <div class="mb-5">
        <h3 class="fw-bold mb-3" style="color: #000">1- التعريف بالمركز:</h3>
        <p class="lead text-muted" style="line-height: 1.8">
          هو الأداة التنفيذية للهيئة العامة للاستثمار والمناطق الحرة فى تفعيل
          منظومة التحول الرقمي عبر بوابة الشبكة الإلكترونية لخدمات المستثمرين
          Investors Services Network (ISN).
          <br />
          وتعود نشأة هذا المركز إلى شهر سبتمبر عام 2018, عندما وافق مجلس إدارة
          الهيئة بجلسته المنعقدة في 2018/9/12 على تفعيل منظومة التحول الرقمي
          بها.
        </p>
      </div>

      <!-- 2- Message -->
      <div class="mb-5">
        <h3 class="fw-bold mb-3" style="color: #000">2- رسالة المركز:</h3>
        <p class="lead text-muted" style="line-height: 1.8">
          توفير خدمات الهيئة العامة للاستثمار والمناطق الحرة بلا أوراق أو هيئة
          رقمية Digital Authority.
        </p>
      </div>

      <!-- 3- Vision -->
      <div class="mb-5">
        <h3 class="fw-bold mb-3" style="color: #000">3- رؤية المركز:</h3>
        <p class="lead text-muted" style="line-height: 1.8">
          استخدام أفضل المناهج, والبرامج, والوسائل لتأهيل واعتماد المهنيين من
          وكلاء المستثمرين الذين يعملون كحلقة وصل بين المستثمرين, والهيئة بحيث
          يتم اعدادهم للمشاركة في تقديم كافة خدمات الهيئة إلكترونياً من خلالهم
          دون التعامل الورقي في توفير هذه الخدمات.
        </p>
      </div>

      <!-- 4- Competencies -->
      <div class="mb-5">
        <h3 class="fw-bold mb-3" style="color: #000">4- اختصاصات المركز:</h3>
        <p class="lead text-muted" style="line-height: 1.8">
          تتمثل المهمة الأساسية للمركز في تأهيل, واعتماد المهنيين للعمل في مجال
          الاستثمار بعد اجتيازهم للبرامج المؤهلة لاعتماد كل مستوى منها كل على
          حدة.
        </p>
      </div>

      <!-- 5- Programs -->
      <div class="mb-5">
        <h3 class="fw-bold mb-3" style="color: #000">
          5- برامج المركز لتأهيل وكلاء المستثمرين للاعتماد:
        </h3>
        <p class="lead text-muted" style="line-height: 1.8">
          تتضمن خطة مركز وكلاء المستثمرين, تنفيذ أربعة برامج تأهيلية لاعتماد
          وكلاء المستثمرين تم ترتيبها تصاعديا من الترتيب الأصغر إلى الترتيب
          الأكبر وفقا للمستويات الأربع التالية:
        </p>

        <ul class="list-unstyled mt-4 pe-3">
          <li class="mb-4">
            <strong class="d-block mb-2 fs-5">• المستوى الأول:</strong>
            <span class="text-muted">برنامج "مندوب التأسيس الإلكتروني المعتمد" (يستهدف تأهيل المشاركين
              فيه ليقوموا بالتأسيس الإلكتروني لكل من المنشآت الفردية وشركات
              الأشخاص المطلوب تأسيسها من جانب المستثمرين).</span>
            <div class="mt-3 ms-4">
              <a href="assets/نموذج استمارة طلب التحاق بالبرنامج التأهيلي الأول.pdf" target="_blank"
                class="d-flex align-items-center mb-2 text-decoration-none">
                <i class="fa-regular fa-file-pdf text-danger ms-2 fs-4"></i>
                <span class="text-secondary me-2">نموذج استمارة طلب التحاق بالبرنامج التأهيلي الأول</span>
              </a>
              <a href="assets/نموذج إقرار طالب الحصول على شهادة اجتياز البرنامج التأهيلي الأول.pdf" target="_blank"
                class="d-flex align-items-center text-decoration-none">
                <i class="fa-regular fa-file-pdf text-danger ms-2 fs-4"></i>
                <span class="text-secondary me-2">نموذج إقرار طالب الحصول على شهادة اجتياز البرنامج التأهيلي
                  الأول</span>
              </a>
            </div>
          </li>
          <li class="mb-4">
            <strong class="d-block mb-2 fs-5">• المستوى الثاني:</strong>
            <span class="text-muted">برنامج "وكيل التأسيس الإلكتروني المعتمد" (يستهدف تأهيل المشاركين
              فيه ليقوموا بالتأسيس الإلكتروني لشركات الأموال (مساهمة , مسئولية
              محدودة , توصية بالأسهم) فضلا عن قيامهم بالتأسيس الإلكتروني لكل من
              المنشآت الفردية وشركات الأشخاص).</span>
            <p class="mt-2 fw-bold text-primary">
              تم الإعداد لتنفيذ هذا البرنامج, وسوف يُتاح التقديم فيه قريبا.
            </p>
          </li>
          <li class="mb-4">
            <strong class="d-block mb-2 fs-5">• المستوى الثالث:</strong>
            <span class="text-muted">برنامج "وكيل المستثمرين الإلكتروني المعتمد" (يستهدف تأهيل
              المشاركين فيه ليقوموا بتوفير كافة خدمات الاستثمار التي تقدمها
              قطاعات الهيئة المختلفة في مرحلة ما بعد تأسيس الشركات مثل توفير
              الموافقات والتراخيص, واعتماد المحاضر والجمعيات, الخدمات الفنية,
              والخدمات الحكومية, فض وتسوية المنازعات, التقييم الاقتصادي
              للمشروعات, وغيرها من خدمات الاستثمار التي تقدمها قطاعات الهيئة
              المختلفة).</span>
            <p class="mt-2 fw-bold text-primary">
              جاري الإعداد لتنفيذ هذا البرنامج.
            </p>
          </li>
          <li class="mb-4">
            <strong class="d-block mb-2 fs-5">• المستوى الرابع:</strong>
            <span class="text-muted">برنامج "خبير الاستثمار المعتمد" (يستهدف تأهيل واعتماد المشاركين
              فيه للتخصص في قطاع استثماري معين مثل قطاع الزراعة أو الصناعة
              وغيرها أو التخصص في العمل في نظام استثماري معين كأنه يصبح خبير
              استثمار معتمد في شئون المناطق الحرة أو خبير استثمار معتمد في شئون
              المناطق الاستثمارية أو التخصص في مجال معين مثل مجال الشركات
              الناشئة أو المسئولية المجتمعية للشركات, وغيرها).</span>
          </li>
        </ul>

        <p class="lead text-muted mt-4" style="line-height: 1.8">
          وتم تصميم البرامج في المستويات الأربع السابقة لتساعد كافة قطاعات
          الهيئة المختصة بتقديم خدمات الاستثمار من التعامل مع وكلاء مستثمرين
          مؤهلين ومعتمدين للتعامل مع مسئولي تقديم هذه الخدمات بتلك القطاعات,
          والتي يأتي في مقدمتها بشكل أساسي ومباشر ما يلي:
        </p>
        <ul class="pe-4 text-muted">
          <li>قطاع خدمات الاستثمار.</li>
          <li>قطاع شئون المناطق الحرة.</li>
          <li>قطاع الأداء الاقتصادي.</li>
          <li>قطاع تنمية الأعمال.</li>
          <li>الإدارة المركزية للمكتب الفني.</li>
          <li>الإدارة المركزية للمناطق الاستثمارية والتكنولوجية.</li>
        </ul>

        <p class="lead text-muted mt-4" style="line-height: 1.8">
          وتم الأخذ في الاعتبار عند تصميم البرامج السابقة, أهمية تحقيق الترابط
          بين البرامج والمستويات الأربعة السابقة والتدرج من المستوى الأول إلي
          المستوى الرابع بمعنى أنه لا يمكن المشاركة في المستوى الثاني أي برنامج
          "وكيل التأسيس الإلكتروني المعتمد" دون اجتياز المستوي الأول أي برنامج
          "مندوب التأسيس الإلكتروني المعتمد" وهكذا. فقد تم التدرج في تصميم هذه
          البرامج لتغطي كافة خدمات وموضوعات الاستثمار بشكل متكامل ومترابط.
        </p>
      </div>

      <!-- 6- Results -->
      <div class="mb-5">
        <h3 class="fw-bold mb-3" style="color: #000">
          6- بعض نتائج أعمال المركز:
        </h3>
        <p class="lead text-muted" style="line-height: 1.8">
          أعلنت الهيئة (مركز وكلاء المستثمرين) بتاريخ 9/1/2019 عن فتح باب طلبات
          التقديم للبرنامج التأهيلي الأول "مندوب التأسيس الإلكتروني المعتمد",
          وذلك على الموقع الإلكتروني للهيئة, وقد تم استقبال طلبات الراغبين في
          المشاركة بالبرنامج اعتبارا من تاريخ 27/1/2019. ويمكن تحديد نتائج تنفيذ
          هذا البرنامج فيما يلي:
        </p>

        <ol class="pe-3 text-muted" style="line-height: 1.8">
          <li class="mb-3">
            قام مركز شئون وكلاء المستثمرين بالهيئة بتنظيم عدد (30) دورة تأهيلية
            للبرنامج المذكور تم عبرها تأهيل عدد (525) مشارك فيه من وكلاء
            المستثمرين.
          </li>
          <li class="mb-3">
            تم إطلاق السجل الإلكتروني لوكلاء المستثمرين المعتمدين لدى الهيئة في
            المستوى الأول كخطوة أولى فعلية لإنشاء الشبكة الالكترونية لخدمات
            المستثمرين Investors Network (ISN) تمهيدا لتقديم كافة خدمات
            الاستثمار إلكترونيا وإلغاء التعامل الورقي في توفير هذة الخدمات, وذلك
            بعد تأهيل مندوبي التأسيس الإلكتروني المعتمدين. ويتضمن هذا السجل – في
            الوقت الراهن - بيانات من تم تأهيلهم في هذا البرنامج, ويمكن الرجوع
            إليه عبر الموقع الإلكتروني للهيئة.
          </li>
          <li class="mb-3">
            يمكن إجمال النتائج المتصلة بتنظيم
            <strong>المستوى الأول " البرنامج التأهيلي مندوب التأسيس الإلكتروني
              المعتمد"</strong>, وذلك على النحو الموضح بالجدول التالي:
          </li>
        </ol>

        <div class="table-responsive my-4">
          <table class="table table-bordered table-striped text-center align-middle">
            <thead class="table-success">
              <tr>
                <th>البند</th>
                <th>المؤشر</th>
                <th>العدد</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>عدد المتقدمين للحصول على البرنامج.</td>
                <td>539 متقدم</td>
              </tr>
              <tr>
                <td>2</td>
                <td>عدد المشاركين الذين تمكنوا من اجتياز البرنامج.</td>
                <td>525 مشارك</td>
              </tr>
              <tr>
                <td>3</td>
                <td>عدد الدورات التأهيلية التي تم تنظيمها.</td>
                <td>30 دورة تأهيلية</td>
              </tr>
              <tr>
                <td>4</td>
                <td>
                  عدد المقيدين بالسجل الإلكتروني لمندوبي التأسيس الإلكتروني
                  المعتمدين لدى الهيئة.
                </td>
                <td>462 مندوب تأسيس إلكتروني معتمد</td>
              </tr>
            </tbody>
          </table>
        </div>

        <ol start="4" class="pe-3 text-muted" style="line-height: 1.8">
          <li class="mb-3">
            تواصل عدد من المستثمرين مع مندوبي التأسيس الإلكتروني الذين تم
            تأهيلهم في المستوى الأول عبر السجل الإلكتروني. الأمر الذي يؤكد تحقيق
            الهدف الأول المبدئي لهذا السجل, وهو سهولة تواصل المستثمرين مع هؤلاء
            الوسطاء من المندوبين ليتولوا إنهاء إجراءات أعمالهم نيابة عنهم.
          </li>
          <li class="mb-3">
            الترويج للمشاركين, حيث تم توزيع وكلاء المستثمرين الذين تم تأهيلهم في
            المستوى الأول جغرافيا على "خريطة الفرص الاستثمارية" المتاحة الموقع
            الإلكتروني للهيئة, بحيث يتوفر للمستثمر الذي يرغب في الاستفادة من
            إحدى هذه الفرص في إحدى المحافظات, أحد هؤلاء المندوبين الذي يعاونه في
            الحصول على خدمات الاستثمار المطلوبة لتنفيذ المشروع أو المشاريع التي
            تتضمنها هذه الفرصة.
            <div class="mt-3 text-center">
              <a href="https://www.investinegypt.gov.eg/English/Pages/exploreMap.aspx?cat=12" target="_blank"
                class="btn btn-outline-primary fw-bold">
                للتعرف أكثر على كافة بيانات وكلاء المستثمرين المتضمنة في الخريطة
                الاستثمارية والتواصل معهم, أضغط هنا
              </a>
            </div>
          </li>
          <li class="mb-3">
            ساهم تنفيذ هذا البرنامج في ترسيخ ثقافة التحول الرقمي لدى المشاركين
            فيه وإدراكهم لأهمية تغيير أسلوبهم في توفير خدمات الاستثمار لوكلائهم
            من المستثمرين من الأسلوب التقليدي الورقي إلى الأسلوب التكنولوجي
            الرقمي.
          </li>
          <li class="mb-3">
            سعى بعض المؤسسات المصرية إلي التعاون مع مركز وكلاء المستثمرين لتأهيل
            واعتماد عدد من المستفيدين بخدماتها من الشباب للعمل في مجال الاستثمار
            إدراكًا منها لأهمية ذلك التأهيل والاعتماد في خلق فرص عمل جديدة
            لهؤلاء الشباب.
          </li>
          <li class="mb-3">
            تحقيق المزيد من التواصل مع وكلاء المستثمرين عبر إنشاء عدد (30)
            مجموعة من خلال تطبيق "الواتس آب" للتواصل المباشر مع كافة المشاركين
            من المجموعات التي تم تنفيذ البرنامج لها خلال الدورات التي قام المركز
            بتنظيمها خلال الفترة الماضية. وهو الأمر الذي يسهل التعرف على مشكلات
            ومقترحات هؤلاء المشاركون في مرحلة ما بعد تنفيذ البرنامج.
          </li>
          <li class="mb-3">
            الفوز في جائزة التميز الحكومي الدورة الثانية 2020 ضمن المراكز العشر
            الأوائل في فئة الابداع والابتكار (مبادرة وكيل المستثمرين المعتمد -
            أكتوبر 2021).
          </li>
        </ol>
      </div>

      <!-- Footer Link -->
      <div class="text-center mt-5 mb-5 p-4 bg-light rounded shadow-sm">
        <h5 class="fw-bold mb-4">
          ويمكن للمستثمرين ووكلاءهم متابعة كل جديد عن المركز من خلال صفحته على
          Linkedin المتاحة على الرابط التالي:
        </h5>
        <a href="https://www.linkedin.com/company/%D9%85%D8%B1%D9%83%D8%B2-%D9%88%D9%83%D9%84%D8%A7%D8%A1-%D8%A7%D9%84%D9%85%D8%B3%D8%AA%D8%AB%D9%85%D8%B1%D9%8A%D9%86/"
          target="_blank" class="btn btn-primary btn-lg d-inline-flex align-items-center gap-2 px-5 py-2">
          <i class="fa-brands fa-linkedin fa-xl"></i>
          اضغط هنا
        </a>
      </div>
    </div>
  </div>
</div>